<div class="dialog-backdrop" (click)="onBackdropClick($event)"></div>
<div class="dialog-content">
  <button class="dialog-close" (click)="exit.emit()">&times;</button>
  @if (title) {
  <div class="dialog-title">{{ title }}</div>
  }
  <div class="dialog-body">{{ message }}</div>
  <div class="dialog-action-row">
    @if (actionLabel) {
    <app-button class="dialog-action" (buttonClickEvent)="exit.emit()"
      >{{ actionLabel }}</app-button
    >
    }
  </div>
  @if (number !== undefined) {
  <div class="dialog-number">{{ number }}</div>
  }
</div>
